// @ts-nocheck
// Small formatting helpers shared across /cti2 — pulled out after the same
// logic turned up copy-pasted in BreakScreen.tsx, teamModel.ts, Topbar.tsx
// and AgentDetailDialog.tsx.
const pad = (n) => String(Math.max(0, Math.floor(n))).padStart(2, '0');

/**
 * H:MM:SS once an hour has elapsed, MM:SS otherwise — for live counters that
 * should stay compact (break timers, work-duration) rather than always
 * carrying a leading "00:" hour segment the way ctiHelpers.formatSeconds
 * does for call durations.
 */
export function formatClock(totalSeconds) {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(sec)}` : `${pad(m)}:${pad(sec)}`;
}

/** First letter of up to the first two words of a name, uppercased. */
export function initialsFromName(name, fallback = '?') {
  return (
    String(name || '')
      .split(/[\s._-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0])
      .join('')
      .toUpperCase() || fallback
  );
}
